import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';
import {
  RootfiIntegrationCategory,
  RootfiSyncConfig,
  RootfiSyncDatamodels,
  RootfiSyncFrequency,
} from '@commenda/types/src/root-fi/types';

// Default sync from date is 4 year ago
const syncFromDate = new Date(
  new Date().setFullYear(new Date().getFullYear() - 4)
)
  .toISOString()
  .split('T')[0];

const SALES_TAX_ACCOUNTING_BILLS_SYNC_CONFIG: RootfiSyncConfig[] =
  isFeatureLaunched(FeatureLaunch.SALES_TAX_ROOTFI_BILLS_SYNC)
    ? [
      {
        integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
        dataModel: RootfiSyncDatamodels.BILLS,
        isEnabled: true,
        syncFrequency: RootfiSyncFrequency.HOURLY,
        syncInterval: 1,
        permissions: {
          CanRead: true,
          CanCreate: true,
          CanUpdate: true,
          CanDelete: false,
        },
        syncFromDate,
      },
      {
        integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
        dataModel: RootfiSyncDatamodels.BILL_CREDIT_NOTES,
        isEnabled: true,
        syncFrequency: RootfiSyncFrequency.HOURLY,
        syncInterval: 1,
        permissions: {
          CanRead: true,
          CanCreate: true,
          CanUpdate: true,
          CanDelete: false,
        },
        syncFromDate,
      },
    ]
    : [];

export const SALES_TAX_ACCOUNTING_SYNC_CONFIG: RootfiSyncConfig[] = [
  ...SALES_TAX_ACCOUNTING_BILLS_SYNC_CONFIG,
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.INVOICES,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.PRODUCTS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.CASH_REFUNDS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.CONTACTS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.INVOICE_CREDIT_NOTES,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.SALES_ORDERS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.CASH_SALES,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
  },
];

export const SALES_TAX_ECOMMERCE_SYNC_CONFIG: RootfiSyncConfig[] = [
  {
    integrationCategory: RootfiIntegrationCategory.ECOMMERCE,
    dataModel: RootfiSyncDatamodels.ECOMMERCE_CUSTOMERS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ECOMMERCE,
    dataModel: RootfiSyncDatamodels.ECOMMERCE_PRODUCTS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ECOMMERCE,
    dataModel: RootfiSyncDatamodels.ECOMMERCE_TRANSACTIONS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    // we need this as transactions are linked with orders
    integrationCategory: RootfiIntegrationCategory.ECOMMERCE,
    dataModel: RootfiSyncDatamodels.ECOMMERCE_ORDERS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
];

const COMPLIANCE_ACCOUNTING_SYNC_CONFIG: RootfiSyncConfig[] = [
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.PROFIT_AND_LOSS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.BALANCE_SHEET,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
];

export const SALES_TAX_PAYMENTS_SYNC_CONFIG: RootfiSyncConfig[] = [
  {
    integrationCategory: RootfiIntegrationCategory.PAYMENTS,
    dataModel: RootfiSyncDatamodels.PAYMENT_INVOICES,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.PAYMENTS,
    dataModel: RootfiSyncDatamodels.PAYMENT_PRODUCTS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.PAYMENTS,
    dataModel: RootfiSyncDatamodels.PAYMENT_CUSTOMERS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.PAYMENTS,
    dataModel: RootfiSyncDatamodels.PAYMENT_CREDIT_NOTES,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
    syncFromDate,
  },
];

export const BOOKKEEPING_SYNC_CONFIG: RootfiSyncConfig[] = [
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.INCOME_STATEMENT,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: false,
      CanUpdate: false,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.BALANCE_SHEET,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: false,
      CanUpdate: false,
      CanDelete: false,
    },
    syncFromDate,
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.CASH_FLOW_STATEMENT,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: false,
      CanUpdate: false,
      CanDelete: false,
    },
    syncFromDate,
  },
];

export const OPERATIONAL_TRANSFER_PRICING_SYNC_CONFIG: RootfiSyncConfig[] = [
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.INCOME_STATEMENT,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.ACCOUNTS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.COMPANY_INFO,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.INVOICES,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.TRACKING_CATEGORIES,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.CURRENCIES,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
  },
  {
    integrationCategory: RootfiIntegrationCategory.ACCOUNTING,
    dataModel: RootfiSyncDatamodels.PRODUCTS,
    isEnabled: true,
    syncFrequency: RootfiSyncFrequency.HOURLY,
    syncInterval: 1,
    permissions: {
      CanRead: true,
      CanCreate: true,
      CanUpdate: true,
      CanDelete: false,
    },
  },
];
